<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" @click="handleVisible">新增第三方授权</el-button>
      </el-col>
      <el-col :span="6">
        <el-input placeholder="请输入第三方名称..." v-model="params.third_name">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table :data="thirdOAuthList" border stripe v-loading="loading">
      <el-table-column prop="id" label="ID" width="40" align="center"></el-table-column>
      <el-table-column prop="third_name" label="第三方名称"></el-table-column>
      <el-table-column prop="app_id" label="APP ID"></el-table-column>
      <el-table-column prop="app_secret" label="APP SECRET"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="created_at" align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.created_at | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{scope.row.updated_at | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="is_disabled" align="center" width="100" label="启用状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_disabled"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949" @change="changeStatus(scope.$index, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <!-- <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增第三方接口授权" :visible.sync="editFormVisible" :before-close="handleCancel">
      <el-form :model="form">
        <el-form-item label="APP ID">
          <el-input v-model="form.app_id"></el-input>
        </el-form-item>
        <el-form-item label="APP SECRET">
          <el-input v-model="form.app_secret">
            <el-button slot="append" @click="generateKeys">生成密钥</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="第三方名称">
          <el-input v-model="form.third_name"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch
            v-model="form.is_disabled"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="0"
            :inactive-value="1">
          </el-switch>
        </el-form-item>
        <el-form-item size="large">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {getOAuthList, createOAuth, updateOAuth, delOAuth} from '@/api/thirdoauth'
import template from '../../../wxapp/template.vue'
export default {
  components: { template },
  data() {
    return {
      loading: false,
      thirdOAuthList: [],
      editFormVisible: false,
      params: {
        page: 1,
        pageSize: 20,
        third_name: ''
      },
      form: {
        app_id: '',
        app_secret: '',
        third_name: '',
        is_disabled: 1,
        remark: '',
      }
    }
  },
  methods: {
    // 检索第三方授权信息
    searchData() {
      this.getThirdOAuthList()
    },
    // 获取第三方授权列表
    getThirdOAuthList() {
      this.loading = true
      getOAuthList(this.params).then(response => {
        this.loading = false
        this.thirdOAuthList = response.data.data.list
      }).catch(error => {
        this.loading = false
        this.$message({
          type: 'error',
          message: '获取列表信息出错'
        })
      })
    },
    // 显示新增面板
    handleVisible() {
      this.editFormVisible = true
    },
    // 触发编辑面板
    handleEdit(index, row) {
      this.form = row
      this.handleVisible()
    },
    // 新增|更新第三方授权信息
    onSubmit() {
      if (this.form.id) {
        updateOAuth(this.form).then(response => {
          this.$message({message: '更新成功', type: 'success'})
          this.handleCancel()
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '更新失败'
          })
        })
      } else {
        createOAuth(this.form).then(response => {
          this.$message({message: '新增成功', type: 'success'})
          this.handleCancel()
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '新增失败'
          })
        })
      }
    },
    // 删除第三方授权信息
    handleDelete(index, row) {
      delOAuth(row.id).then(response => {
        this.$message({message: '删除成功', type: 'success'})
        this.getThirdOAuthList()
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '删除失败'
        })
      })
    },
    // 修改指定数据的状态
    changeStatus(index, row) {
      updateOAuth(row).then(response => {
        this.$message({message: '更新成功', type: 'success'})
        this.handleCancel()
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '更新失败'
        })
      })
    },
    // 关闭编辑面板
    handleCancel() {
      this.getThirdOAuthList()
      this.form.app_id = ''
      this.form.app_secret = ''
      this.form.third_name = ''
      this.form.remark = ''
      this.form.is_disabled = 1
      this.editFormVisible = false
    },
    // 生成密钥
    generateKeys() {
      var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
      var len = t.length
      var n = ""
      for (var i = 0; i < 32; i++) {
        n += t.charAt(Math.floor(Math.random() * len))
      }
      this.form.app_secret = n
    }
  },
  mounted() {
    this.getThirdOAuthList()
  }
}
</script>




// WEBPACK FOOTER //
// list.vue?941aba40